module.exports = pdfjsLib;